import { UnauthenticatedAnalyticSessionProvider } from "@octopusdeploy/portal-analytics";
import * as React from "react";
import { Provider } from "react-redux";
import { PageChangedCallbacks } from "~/PageChangedCallbacks";
import DynamicExtensionsLoader from "~/areas/dynamicExtensions/dynamicExtensionsLoader";
import { ClientConnector } from "~/areas/infrastructure/components/ClientConnector/ClientConnector";
import { DevToolsContextProvider } from "~/components/DevTools/DevToolsContext";
import ErrorBoundary from "~/components/ErrorBoundary/ErrorBoundary";
import { ErrorContextProvider } from "~/components/ErrorContext/ErrorContext";
import { LogErrorDisplayer } from "~/components/LogErrors/LogErrorDisplayer";
import { LogEventCapturer } from "~/components/LogErrors/LogEventCapturer";
import { OctopusRouter } from "~/components/OctopusRouter/OctopusRouter";
import { PageRegistrationProvider } from "~/routing/pageRegistrations/PageRegistrationContext";
import store from "~/store";
import { ThemeFromLocalStorage } from "./components/Theme/ThemeFromLocalStorage";
const App: React.FC = () => {
    return (<LogEventCapturer>
            <UnauthenticatedAnalyticSessionProvider>
                <ErrorBoundary>
                    <ErrorContextProvider>
                        <Provider store={store}>
                            <PageRegistrationProvider>
                                <PageChangedCallbacks />
                                <ThemeFromLocalStorage>
                                    <LogErrorDisplayer />
                                    <ClientConnector renderWhenConnected={() => (<DevToolsContextProvider>
                                                <OctopusRouter />
                                                <DynamicExtensionsLoader />
                                            </DevToolsContextProvider>)}/>
                                </ThemeFromLocalStorage>
                            </PageRegistrationProvider>
                        </Provider>
                    </ErrorContextProvider>
                </ErrorBoundary>
            </UnauthenticatedAnalyticSessionProvider>
        </LogEventCapturer>);
};
App.displayName = "App"
export default App;
